import { http } from './config'
import authHeader from './auth-header'

export default {
  consultaLoja: (cpf) => {
    return http.get(`/temsaude/consulta-loja/${cpf}`, {
      headers: authHeader(),
    })
  },

  consultaCartaoStatus: (cpf, cartao) => {
    return http.get(`/temsaude/consulta-cartao-status/${cpf}/${cartao}`, {
      headers: authHeader(),
    })
  },

  consultaLoteLoja: (dataInicial, dataFinal) => {
    return http.get('/temsaude/consulta-lote-loja', {
      params: {
        'data-inicial': dataInicial,
        'data-final': dataFinal,
      },
      headers: authHeader(),
    })
  },

  ativarCartao: (cpf, cartao) => {
    return http.get(`/temsaude/novo-status/${cpf}/${cartao}`, {
      headers: authHeader(),
    })
  },

  suspenderCartao: (cpf, cartao) => {
    return http.get(`/temsaude/novo-status-suspender/${cpf}/${cartao}`, {
      headers: authHeader(),
    })
  },

  cancelarCartao: (cpf, cartao) => {
    return http.get(`/temsaude/novo-status-cancelar/${cpf}/${cartao}`, {
      headers: authHeader(),
    })
  },

  adesaoCartao: (cpf, cartao) => {
    return http.get(`/temsaude/adesao/${cpf}/${cartao}`, {
      headers: authHeader(),
    })
  },
}
